<template>
    <a @click="onClick" class="accordion-link">
        <span class="icon" :class="{ 'is-visible': isVisible }">
            <i class="fa fa-caret-down"></i>
        </span>
        <span>
            <slot></slot>
        </span>
    </a>
</template>

<script>
    export default {
        name: "accordion-link",
        inheritAttrs: false,
        props: ["isVisible"],
        methods: {
            onClick() {
                this.$emit("click");
            },
        },
    };
</script>

<style scoped></style>
